var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1.5,
    y: 1.5,
    fill: "#260C6A",
    rx: 18.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1.5,
    y: 1.5,
    stroke: "#fff",
    strokeWidth: 3,
    rx: 18.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F9",
    d: "M25.6 24.02c-.812 0-1.537.306-2.091.788l-7.606-4.25c.053-.236.096-.471.096-.717s-.043-.481-.096-.717l7.52-4.209c.576.512 1.334.83 2.176.83 1.77 0 3.2-1.373 3.2-3.073S27.37 9.6 25.6 9.6s-3.2 1.372-3.2 3.072c0 .246.043.482.096.717l-7.52 4.21a3.26 3.26 0 0 0-2.176-.83c-1.77 0-3.2 1.372-3.2 3.072s1.43 3.072 3.2 3.072c.843 0 1.6-.317 2.176-.83l7.595 4.261a2.8 2.8 0 0 0-.085.666c0 1.648 1.397 2.99 3.114 2.99 1.718 0 3.115-1.342 3.115-2.99 0-1.65-1.397-2.99-3.115-2.99"
  })));
};
export default SvgShare;